<app-button *ngIf="visible" class="w-fit" [type]="'small'" [iconId]="'arrow-left'" [contentPosition]="'left'" (action)="back.emit()">
	{{ text | translate }}
</app-button>
